import VideoDetail from '@/components/pages/artist/VideoDetail'
import AlbumDetail from '@/components/pages/artist/AlbumDetail'

export default [
  { path: '/video/:id/', name: 'video-detail', component: VideoDetail },
  { path: '/album/:id/', name: 'album-detail', component: AlbumDetail }
]



// WEBPACK FOOTER //
// ./src/router/content.js